import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ESTABLISHMENTS_LIST_KEY } from 'modules/client/establishment/constants';
import { EstablishmentService } from 'modules/client/establishment/services';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

export const useDeleteEstablishment = (id: string, onClose?: () => void) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('establishment');
  return useMutation(() => EstablishmentService.delete(id), {
    onSuccess: (data) => {
      toast.success(t('successDeleted'));
      onClose?.();
      queryClient.invalidateQueries([ESTABLISHMENTS_LIST_KEY]);
      queryClient.invalidateQueries([id]);
    },
  });
};
